import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { NetworkThemeTopThreadsLoadAction } from '../../domains/networkThemeTopThreads/actions.types';

import { NetworkThemeTopThreadsLifecycle } from './types';

const initialState: NetworkThemeTopThreadsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<NetworkThemeTopThreadsLifecycle, NetworkThemeTopThreadsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'NETWORK_THEME_TOP_THREADS.LOAD_PENDING':
      return setPending();
    case 'NETWORK_THEME_TOP_THREADS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.networkThemeTopThreads);
    case 'NETWORK_THEME_TOP_THREADS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
